import React from 'react';
import { CtaLink, Heading, Kicker, Lead, Section } from './ui';
import { whatsappUrl } from '../../data/links';
import { steps } from '../../data/vcars';
export function StepsSection() {
  return <Section id="como-funciona" className="bg-[#0c0e12]" data-id="element-99" data-mp="284483p0ikcqm">
      <Kicker data-id="element-100" data-mp="281hzrn5stt7c">Paso a paso</Kicker>
      <Heading className="mt-4 text-white" data-id="element-101" data-mp="241hdjgcgkdpq">¿Cómo funciona VCARS?</Heading>
      <Lead className="mt-4 max-w-xl text-white/55" data-id="element-102" data-mp="2406bbkynve0q">
        Un proceso simple para que no pierdas tiempo.
      </Lead>

      <ol className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-id="element-103" data-mp="1bdlfa778qdqu">
        {steps.map((step, index) => <li key={step.title} className="relative" data-id="element-104" data-mp="1p5ryy39lr2v1" data-mpi={index}>
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#3b6bff] text-sm font-bold text-white" data-id="element-105" data-mp="1p6kz2le22u47">
              {index + 1}
            </div>
            <h3 className="font-display mt-4 text-xl font-bold leading-tight text-white" data-id="element-106" data-mp="wmw5n99fh6p3">
              {step.title}
            </h3>
            <p className="mt-2 text-base leading-relaxed text-white/60" data-id="element-107" data-mp="2zg8krwrj6mb3">
              {step.text}
            </p>
          </li>)}
      </ol>

      <CtaLink href={whatsappUrl('Hola VCARS, quiero hablar con un asesor.')} label="Hablar con un asesor" className="mt-10" data-id="element-108" data-mp="34e0mtjlw3ot0" />
    </Section>;
}